import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { useCustomer } from 'src/public/components/online_ordering/CustomerContextCommon'
import { useLoyalty } from 'src/public/components/online_ordering/LoyaltyContext'
import Popover from 'src/shared/components/common/popover/Popover'
import { t } from 'src/translations'

import Image from 'shared/components/common/Image'

import CheckoutSection from 'public/components/default_template/online_ordering/checkout/CheckoutSection'

interface Props {
  restaurantName?: string
}

export const ThirdPartyLoyaltyGuestConsentForm = ({
  restaurantName
}: Props) => {
  const {
    setAllowLookup,
    allowLookup,
    hasLoyaltyAccount,
    loadingLoyaltyAccount
  } = useLoyalty()
  const { customer } = useCustomer()

  restaurantName = restaurantName || 'restaurant'

  if (!allowLookup) {
    return (
      <CheckoutSection
        title={t('third-party-loyalty-guest-consent-form.rewards')}
      >
        <div className='loyaltyRedemption'>
          <div className='header'>
            {t('third-party-loyalty-guest-consent-form.get-rewarded')}
          </div>
          <div className='loyaltyConsentContent'>
            {t(
              'third-party-loyalty-guest-consent-form.lookup-account-to-earn-points'
            )}
          </div>
          <button
            type='button'
            className='submitButton primaryCta consentButton'
            onClick={(e) => {
              setAllowLookup(true, true)
              e.stopPropagation()
            }}
            data-testid='loyalty-3p-consent'
          >
            {t('third-party-loyalty-guest-consent-form.lookup-my-rewards')}
          </button>
          <div className='note'>
            {t(
              'third-party-loyalty-guest-consent-form.lookup-rewards-permission-notice'
            )}
          </div>
        </div>
      </CheckoutSection>
    )
  } else if (loadingLoyaltyAccount) {
    return (
      <div className='loyaltyRedemption'>
        <div className='loyaltyLoading'>
          <CheckoutSection
            title={t('third-party-loyalty-guest-consent-form.rewards')}
          >
            <Skeleton
              count={4}
              containerTestId='loader-skeleton'
              height='18px'
            />
          </CheckoutSection>
        </div>
      </div>
    )
  } else if (!hasLoyaltyAccount) {
    return (
      <CheckoutSection
        title={t('third-party-loyalty-guest-consent-form.rewards')}
      >
        <div className='loyaltyRedemption'>
          <div className='errorHeader'>
            {t(
              'third-party-loyalty-guest-consent-form.no-loyalty-account-found'
            )}
          </div>
          <div className='loyaltyConsentContent'>
            {t(
              'third-party-loyalty-guest-consent-form.confirm-email-phone-match',
              { restaurantName }
            )}
            <Popover
              contextKey='loyaltyInfoTooltip'
              arrowClassName='tooltipArrow'
              target={({ open }) => {
                return (
                  <button
                    className='loyaltyInfoButton'
                    onClick={(e) => {
                      e.preventDefault()
                      open()
                    }}
                    aria-label={t(
                      'third-party-loyalty-guest-consent-form.show-more-info'
                    )}
                  >
                    <Image src='icons/info.svg' alt='' />
                  </button>
                )
              }}
            >
              <div className='loyaltyConsentTooltipContent'>
                <div data-testid='email'>
                  {t('third-party-loyalty-guest-consent-form.email-label', {
                    email: customer?.email
                  })}
                </div>
                {customer?.phone && (
                  <div data-testid='phone'>
                    {t('third-party-loyalty-guest-consent-form.phone-label', {
                      phone: customer?.phone
                    })}
                  </div>
                )}
              </div>
            </Popover>
          </div>
        </div>
      </CheckoutSection>
    )
  }

  return null
}
